module.exports = " <div class=btnshow> <div class=navbar-wrapper> <div class=navbar> <div class=left> </div> <div class=title>PACO-UI</div> <div class=right></div> </div> </div> <list icon=true><span slot=title>文字标题</span><span slot=desc>内容内容</span></list> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/ListView.vue
// module id = 151
// module chunks = 1